module.exports = __webpack_public_path__ + "static/media/edit.f663e4c7.svg";